import React from 'react'
import styled from 'styled-components'

import { Container, SizeType } from '@ui/blocks/Container'

interface WrappedContainerProps {
  className?: string
  containerClassName?: string
  children: React.ReactNode
  background: 'green' | 'beige' | 'floralWhite' | 'aquaSqueeze'
  padding?: string
  hasHiddenOverflow?: boolean
  containerSize?: SizeType
  noPadding?: boolean
}

const StyledContainerWrapper = styled.div<WrappedContainerProps>`
  width: 100%;
  padding: 4.8rem 0;
  ${({ hasHiddenOverflow }) => hasHiddenOverflow && 'overflow: hidden;'}
  background-color: ${({ background, theme }) => {
    switch (background) {
      case 'green':
        return theme.global.colors.elemyGreen
      case 'beige':
        return theme.global.colors.beige
      case 'floralWhite':
        return theme.global.colors.floralWhite
      case 'aquaSqueeze':
        return theme.global.colors.aquaSqueeze
    }
  }};

  h1,
  h2,
  h3,
  h4,
  h5 {
    color: ${({ background, theme }) =>
      background === 'green' ? theme.global.colors.white : theme.global.colors.elemyGreen};
  }

  @media ${({ theme }) => theme.device.tablet} {
    padding: 0;
  }
`

export const WrappedContainer = ({
  children,
  containerClassName,
  className,
  background,
  padding,
  hasHiddenOverflow,
  containerSize,
  noPadding
}: WrappedContainerProps) => {
  return (
    <StyledContainerWrapper
      hasHiddenOverflow={hasHiddenOverflow}
      background={background}
      className={className}
      padding={padding}>
      <Container size={containerSize} className={containerClassName} noPadding={noPadding}>
        {children}
      </Container>
    </StyledContainerWrapper>
  )
}
